/**
 * User role constants for the Journal Management System
 */
export const ROLES = {
  AUTHOR: 'AUTHOR',
  REVIEWER: 'REVIEWER',
  EDITOR: 'EDITOR',
  CHIEF_EDITOR: 'CHIEF_EDITOR',
  MANAGING_CHIEF_EDITOR: 'MANAGING_CHIEF_EDITOR',
  EDITORIAL_BOARD_MEMBER: 'EDITORIAL_BOARD_MEMBER',
  ADMIN: 'ADMIN'
};

/**
 * Helper functions for role-based access control
 */
export const hasRole = (user, role) => {
  if (!user) return false;
  
  // Check if user has a single role property
  if (user.role) {
    return user.role === role;
  }
  
  // Check if user has roles array
  if (user.roles && Array.isArray(user.roles)) {
    return user.roles.includes(role);
  }
  
  return false;
};

/**
 * Check if user has any of the specified roles
 * @param {Object} user - User object
 * @param {Array} roles - Array of roles to check
 * @returns {boolean} - True if user has any of the roles
 */
export const hasAnyRole = (user, roles) => {
  if (!user || !roles || !Array.isArray(roles)) return false;
  
  return roles.some(role => hasRole(user, role));
};
